import React, { Component } from 'react';
import { GraphQLClient, request } from 'graphql-request';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './actions';
import { currentUser } from './queries';
import { getToken, getStore, clearLocalStorage } from './utils';

import Loading from './components/Loading/Auth';
import Dashboard from './components/Dashboard';

class Auth extends Component {
  state = {
    isLoggedIn: undefined,
  }

  componentDidMount = async () => {
    const token = await getToken();

    if (!token) {
      this.props.history.push('/login');
      clearLocalStorage();
    } else {
      const graphQLClient = new GraphQLClient(process.env.REACT_APP_GRAPHQL_ENDPOINT, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      });

      graphQLClient.request(currentUser)
        .then((res) => {
          this.props.saveUser(res.currentUserPortal);
          this.setState({ isLoggedIn: true });

          const storeId = getStore();
          if (storeId) this.handleStore(storeId);
        })
        .catch(() => {
          this.props.history.push('/login');
          clearLocalStorage();
        });
    }
  }

  handleStore = (id) => {
    const query = `
      query {
        storeDataPortal(storeId: "${id}", userId: "${this.props.user.id}") {
          id
          name
          avatarUrl
          status
          roleType
        }
      }
    `;

    request(process.env.REACT_APP_GRAPHQL_ENDPOINT, query)
      .then((res) => {
        this.props.saveStore(res.storeDataPortal);
      })
      .catch(console.error);
  }

  render() {
    if ((!this.state.isLoggedIn && !getStore()) || (getStore() && !this.props.store.roleType)) {
      return <Loading />;
    }

    return (
      <Dashboard />
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  store: state.store,
});

const mapDispathToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapDispathToProps)(Auth);
